// extracted by mini-css-extract-plugin
module.exports = {"LPPage":"AmazonECS_LPPage___nhF9","contents":"AmazonECS_contents__2IGua"};